import { Toaster as Sonner } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      position="top-center"
      expand={false}
      richColors={false}
      toastOptions={{
        style: {
          fontFamily: "'Fredoka One', sans-serif",
          fontWeight: "700",
          fontSize: "1rem",
          background: "#16103a",
          color: "#ffffff",
          border: "2.5px solid #000",
          borderRadius: "1rem",
          boxShadow: "4px 4px 0 #000",
          padding: "0.65rem 1.1rem",
        },
        classNames: {
          error:   "!bg-[#3d0014] !border-[#ff3355] !text-white",
          success: "!bg-[#003d20] !border-[#3dffa0] !text-black",
          warning: "!bg-[#3d2a00] !border-[#ffe600] !text-white",
          info:    "!bg-[#001e3d] !border-[#00f5ff] !text-white",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
